import okxIcon from "@/assets/icons/okx.svg?url";
import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/Icon";
import { Label } from "@/components/ui/label";
import { RadioGroupItem } from "@/components/ui/radio-group";

export interface ApiKey {
  id: string;
  name: string;
  exchange: "okx";
  isActive: boolean;
  isDemo?: boolean;
  status?: "active" | "connecting" | "error";
  errorCode?: string;
}

interface ApiKeyItemProps {
  apiKey: ApiKey;
  onEdit?: (id: string) => void;
  onDelete?: (id: string) => void;
  showActions?: boolean;
  disabled?: boolean;
}

export const ApiKeyItem = ({
  apiKey,
  onEdit,
  onDelete,
  showActions = true,
  disabled,
}: ApiKeyItemProps) => {
  const radioId = `api-key-${apiKey.id}`;

  const getStatusBadge = () => {
    const status = apiKey.status || (apiKey.isActive ? "active" : "connecting");

    if (status === "active") {
      return (
        <span className="fs-200 rounded bg-success/20 px-2 py-1 font-medium text-success">
          Активен
        </span>
      );
    }

    if (status === "error") {
      return (
        <span className="fs-200 rounded bg-danger/20 px-2 py-1 font-medium text-danger">
          {apiKey.errorCode || "Ошибка 432"}
        </span>
      );
    }

    return (
      <span className="fs-200 rounded bg-neutral-200/40 px-2 py-1 font-medium text-neutral-400">
        Подключается
      </span>
    );
  };

  return (
    <div className="flex min-h-14 items-center justify-between border-b border-neutral-800 px-4 py-2">
      <Label
        htmlFor={radioId}
        className="flex flex-1 items-center gap-3"
      >
        <RadioGroupItem
          id={radioId}
          value={apiKey.id}
          className="border-neutral-600"
        />
        <div className="flex items-center gap-2.5">
          <img
            src={okxIcon}
            alt="OKX"
            className="size-6 object-contain"
          />
          <span className="fs-300 font-semibold text-neutral-100">{apiKey.name}</span>
          {apiKey.isDemo && (
            <span className="fs-200 rounded bg-warning/20 px-2 py-0.5 font-medium text-warning">
              demo
            </span>
          )}
        </div>
      </Label>

      {showActions ? (
        <div className="flex items-center gap-3.5">
          <Button
            variant="neutral"
            buttonType="icon"
            size="sm"
            rounded="full"
            onClick={() => onEdit?.(apiKey.id)}
            disabled={disabled}
            icon={
              <Icon
                name="edit"
                className="text-neutral-200"
              />
            }
          />
          <Button
            variant="destructive"
            buttonType="icon"
            size="sm"
            rounded="full"
            onClick={() => onDelete?.(apiKey.id)}
            disabled={disabled}
            icon={
              <Icon
                name="trash"
                className="text-danger"
              />
            }
          />
        </div>
      ) : (
        <div className="flex items-center">
          {getStatusBadge()}
        </div>
      )}
    </div>
  );
};
